import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-compaign-huggies" }
const _hoisted_2 = { class: "screen-top" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "screen-top-main" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "screen-name" }, " #비닐포장재 #하기스네이처메이드 #쓰담쓰담하기스 #고품질자원화 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "screen-time" }, " 캠페인 기간 : 3월 25일 ~ 5월 25일 ", -1)
const _hoisted_8 = { class: "box-compaign-info" }
const _hoisted_9 = { class: "compaign-info" }
const _hoisted_10 = { class: "box-main-img" }
const _hoisted_11 = { class: "box-main-img-content" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 소중한 우리 아이를 쓰담쓰담, ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 소중한 우리 지구를 쓰담쓰담. ", -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"group-p\"><p>우리가 사용한 비닐 포장재의 올바른 분리배출을 위해</p><p>유한킴벌리 하기스 네이처메이드와 쓰레기 없는 세상을 꿈꾸는 테라사이클이 만났어요!</p></div><div class=\"group-p\"><p>비닐 포장재의 LDPE/HDPE 분리배출 마크 확인 후</p><p>차곡차곡 쓰담박스에 잘 모아서 테라사이클로 보내주세요.</p></div><div class=\"group-p\"><p class=\"important\"> 올바른 방법으로 비닐 포장재를 쓰담박스에 담아 주신 분에게 추첨을 통해 </p><p class=\"important\"> 재활용 소재로 만든 하기스 캠핑박스 또는 네이처메이드 오가닉코튼커버를 드립니다. </p></div><div class=\"group-p\"><p>수거한 비닐 포장재는 재활용 공정을 통해 고품질 원료가 되어</p><p>국내에서 자원으로 재사용될 수 있도록 필요로 하는 수급처를 발굴하여 전달할 예정입니다.</p></div>", 4)
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "screen-bottom" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = { class: "symbol-group" }
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "name" }
const _hoisted_30 = { class: "indicator-container" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "tab-1" }
const _hoisted_33 = { class: "btn-group" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h4", { class: "title-line" }, " 캠페인 일정 ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 쓰담박스 신청 일정 : 3월 25일 ~ 4월 29일 ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 수거기간 : 4월 22일 ~ 5월 25일 ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 리워드 발송 : 6월 2주차부터 순차 발송 ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "important" }, " (쓰담박스 신청은 조기마감 될 수 있으며, 맘큐 페이지에서 쓰담박스 신청이 가능합니다.) ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "box-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
        /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " 비닐 포장재 모으기 "),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "1"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 비닐 포장재 안의 내용물을 비워주세요. ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "2"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 이물질이 묻어 있는 경우 깨끗하게 씻어주세요. ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "3"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 비닐을 건조해 주세요. ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "4"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 차곡차곡 쓰담박스에 담아주세요. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
        /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " 수거 신청 "),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "1"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 쓰담박스에 LDPE/HDPE 비닐을 차곡 차곡 담아주세요. ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "2"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 쓰담박스가 열리지 않도록 테이프로 밀봉해주세요. ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "3"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 상단 ‘쓰담박스 수거 신청하기’ 버튼을 눌러주세요. ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card-item" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "index" }, "4"),
          /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, " 수거 신청 완료 후 박스를 현관 문 앞에 놓아주세요. 접수일로부터 3~4일 이내 택배 기사님께서 방문하여 수거할 예정입니다. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_41 = { class: "box-notice" }
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "notice-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "notice-title" }, " 잠깐! "),
  /*#__PURE__*/_createElementVNode("p", null, " 여러분이 보내주신 쓰담박스는 테라사이클에 도착해 검수 과정을 거치게 됩니다. "),
  /*#__PURE__*/_createElementVNode("p", null, " 만약 LDPE/HDPE 이외의 비닐 포장재를 넣거나 오염물이 심할 경우, 리워드 추첨 대상에서 제외될 수 있습니다. ")
], -1)
const _hoisted_44 = { class: "tab-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h4", { class: "title-line" }, " 내가 보낸 쓰담박스의 재활용 공정 프로세스 ", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 비닐 포장재를 쓰담 박스에 담아 테라사이클로 보내주시면 이렇게 재활용됩니다. ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 쉽게 쓰고 버려지는 비닐 포장재, 재활용 공정에는 긴 시간이 걸려요. ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 잘 재활용되기 위해서는 기다림의 시간이 필요하답니다! ", -1)
const _hoisted_49 = { class: "box-card" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-12 col-md-4" }
const _hoisted_52 = { class: "card" }
const _hoisted_53 = ["src"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "step-index" }, " STEP 1. ", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "step-name" }, " 방문 수거 ", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 테라사이클 플랫폼 가입 시 ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 기재해 주신 주소로 방문해 ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 쓰담박스를 수거해 갑니다. ", -1)
const _hoisted_59 = { class: "col-12 col-md-4" }
const _hoisted_60 = { class: "card" }
const _hoisted_61 = ["src"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "step-index" }, " STEP 2. ", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "step-name" }, " 분류/세척 ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " LDPE / HDPE 비닐 포장재가 ", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 고품질 원료가 될 수 있도록 ", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 분류/세척 과정을 거칩니다. ", -1)
const _hoisted_67 = { class: "col-12 col-md-4" }
const _hoisted_68 = { class: "card" }
const _hoisted_69 = ["src"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "step-index" }, " STEP 3. ", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "step-name" }, " 재활용 공정 ", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 테라사이클을 통해 ", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 재활용 공정 과정을 거쳐 ", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "card-desc" }, " 고품질 원료가 될 준비를 합니다. ", -1)
const _hoisted_75 = { class: "tab-3" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("h4", { class: "title-line" }, " 리워드 ", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 쓰담박스에 LDPE/HDPE 비닐을 차곡 차곡 모아 테라사이클로 보내주세요. ", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 제공된 쓰담박스에 올바른 방법으로 비닐 포장재를 담아 주신 분에게 추첨을 통해 리워드를 제공합니다. ", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("p", { class: "desc important" }, " *당첨자는 선별 작업 후 개별 알림톡을 통해 안내될 예정입니다. ", -1)
const _hoisted_80 = { class: "box-card" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "box-card-title" }, " 당첨자 발표 ", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "box-card-subtitle" }, " 6월 2주차 (예정) ", -1)
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-12 col-md-6" }
const _hoisted_85 = { class: "card border-right" }
const _hoisted_86 = { class: "box-card-content" }
const _hoisted_87 = ["src"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("p", { class: "card-name" }, " 하기스 캠핑박스 ", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("p", { class: "card-name important" }, " 재활용 소재로 만들어졌어요! ", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "tag" }, " 2022명 ", -1)
const _hoisted_91 = { class: "col-12 col-md-6" }
const _hoisted_92 = { class: "card" }
const _hoisted_93 = { class: "box-card-content" }
const _hoisted_94 = ["src"]
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", { class: "card-name" }, " 네이처메이드 오가닉코튼커버 ", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "tag" }, " 2022명 ", -1)
const _hoisted_97 = { class: "tab-4" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h4", { class: "tab-title" }, " FAQ ", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 쓰담쓰담 캠페인은 무엇인가요? ", -1)
const _hoisted_101 = ["src"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 쓰담쓰담 캠페인은 올바른 비닐 포장재 분리배출 교육과 독려를 위해 기획됐습니다. 참여하시면서 직접 비닐 포장재의 분리배출 마크를 확인하는 습관을 형성하고, 자원순환에 동참하시기를 바라는 마음으로 여러분의 올바른 참여를 응원합니다. ", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 신청이 완료되었는지 어떻게 확인하나요? ", -1)
const _hoisted_105 = ["src"]
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 신청이 완료되면 등록하신 번호로 쓰담박스 배송 관련 알림톡이 발송될 예정입니다. 참여 신청 관련 문의 사항은 테라사이클 카카오톡 채널로 문의 부탁드립니다. ", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 쓰담박스 수거신청 정보를 수정하고 싶습니다. ", -1)
const _hoisted_109 = ["src"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 신청인 정보 변경은 ‘회원 프로필 – 프로필 수정하기’에서 수정 부탁드립니다. ", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 수거 박스를 여러 개 보내주실 수 있나요? ", -1)
const _hoisted_113 = ["src"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 쓰담박스는 자원순환에 대한 인식을 많은 분과 공유하고자 개인에게 1인당 1개씩 제공됩니다. 제공되는 박스에 35개 이상의 최대한 많은 비닐을 차곡차곡 담아 보내주시면 일상 속 유용한 자원으로 다시 사용될 수 있도록 노력하겠습니다. ", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 개인정보는 어떻게 활용되나요? ", -1)
const _hoisted_117 = ["src"]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 회원님의 개인정보는 수거를 위한 택배 서비스 이용을 위해 사용되며, 신규 서비스 및 이벤트, 캠페인 정보 등을 위해 활용됩니다. 만일 개인정보에 비동의하실 경우에는 서비스 이용이 어려우실 수 있다는 점 참고 부탁드리겠습니다. ", -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 쓰담박스 수거 신청 취소는 어떻게 하나요? ", -1)
const _hoisted_121 = ["src"]
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "쓰담박스 수거 신청 취소의 경우 카카오톡 채널에서 [테라사이클]을 검색해"),
  /*#__PURE__*/_createElementVNode("div", null, "‘쓰담쓰담 캠페인 수거 신청 취소’로 문의 주시면 빠르게 확인 도와드리겠습니다.")
], -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 수거 신청 후 기사님께서 언제 방문하시나요? ", -1)
const _hoisted_125 = ["src"]
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 평일 기준 3~4일 이내에 신청하신 주소로 택배 기사님께서 방문하실 예정입니다. ", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 수거 시 택배 비용은 본인 부담인가요? ", -1)
const _hoisted_129 = ["src"]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 쓰담박스 수거는 무료입니다. ‘쓰담박스 수거 신청하기’ 버튼을 누르신 후 쓰담박스를 문 앞에 내놓으시면 택배사에서 방문하여 수거할 예정입니다. ", -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 캠페인 기간 내에 박스를 다 채우지 못하면 어떻게 하나요? ", -1)
const _hoisted_133 = ["src"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 사전에 공지된 캠페인 기간 내에 쓰담쓰담 박스를 다 채우지 못하여 수거 신청하지 않으실 경우 리워드 추첨 대상에서 제외될 수 있습니다. ", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 캠페인 기간이 지났는데 보내도 되나요? ", -1)
const _hoisted_137 = ["src"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 수거 신청은 사전에 공지된 수거 기간에만 가능하니 미리 일정을 확인해 주시기 바랍니다. 신청 기간을 놓친 참여자분들께서는 환경을 위해 모은 비닐 포장재를 가정에서 꼭 자체적으로 분리하여 배출해 주시면 감사하겠습니다. ", -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 어떤 물품이 수거 가능한가요? ", -1)
const _hoisted_141 = ["src"]
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " HDPE / LDPE 분리배출 마크를 확인해주세요. HDPE/ LDPE 비닐 포장재는 모두 가능합니다. ", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 박스가 망가졌는데 어떻게 하나요? ", -1)
const _hoisted_145 = ["src"]
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 박스 파손 시, 폐기물 절감 차원에서 새로운 박스가 재발송 되지 않습니다. 가정에서 발생한 다른 종이 박스에 담아 보내주세요. 본 캠페인이 환경을 위한 캠페인이다 보니 많은 수거 박스를 사용하게 되면 이 또한 폐기물이 또다시 나올 수 있는 문제기에 이 부분은 양해 부탁드립니다. ", -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 수거한 비닐 포장재는 어디에 사용되나요? ", -1)
const _hoisted_149 = ["src"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 수거한 LDPE/HDPE 비닐은 재활용되어 새로운 재활용 원료로 재탄생하게 됩니다. 재활용 원료는 재사용될 수 있도록 필요로 하는 수급처를 발굴하여 전달될 예정입니다. ", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 수거한 비닐 포장재 재활용은 국내에서 이루어지나요? ", -1)
const _hoisted_153 = ["src"]
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 수거한 LDPE/HDPE 비닐 포장재의 재활용 공정은 국내 재활용 업체에서 진행될 예정입니다. ", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 테라사이클은 무슨 기업인가요? ", -1)
const _hoisted_157 = ["src"]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " ‘테라사이클’은 재활용이 어려운 것을 재활용할 수 있도록 솔루션을 제공하는 글로벌 재활용 컨설팅 기업입니다. 다양한 기업들과 협력하여 버려지는 쓰레기가 재활용될 수 있도록 다양한 재활용 캠페인을 기획하고 소재별로 수거에서 가공까지 잘될 수 있도록 재활용 과정을 관리 감독하고 있습니다. ", -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 리워드는 무엇인가요? ", -1)
const _hoisted_161 = ["src"]
const _hoisted_162 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, [
  /*#__PURE__*/_createTextVNode(" 유한킴벌리 하기스 네이처메이드와 테라사이클의 쓰담쓰담 캠페인에 참여해 주시고 올바른 방법으로 비닐 포장재를 수거하여 보내주신 참가자분들께 추첨을 통해 재생 PP로 제작한 하기스 캠핑박스 또는 하기스 네이처메이드 오가닉코튼커버를 리워드로 제공 드릴 예정입니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "important" }, " * 제품 하단에 간혹 보이는 흰색 자국은 재활용 원료 사용을 위한 제조 공정에서 발생한 것으로 불량이 아닌 자연스러운 현상입니다. ")
], -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 리워드는 언제 발송되나요? ", -1)
const _hoisted_165 = ["src"]
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 리워드는 보내주신 쓰담박스 선별 후 6월 둘째 주부터 순차적으로 발송될 예정입니다. ", -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " 수거품목 예시 ", -1)
const _hoisted_169 = ["src"]
const _hoisted_170 = { class: "faq-content" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", null, "올바른 분리배출 방법을 통해 비닐 포장재를 재활용해주세요!", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("div", null, "쓰담쓰담 캠페인은 일상 속 많은 LDPE와 HDPE 비닐 포장재를 수거 및 재활용합니다.", -1)
const _hoisted_173 = { class: "box-img-card" }
const _hoisted_174 = { class: "img-card" }
const _hoisted_175 = ["src"]
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", { class: "img-card-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, " LDPE "),
  /*#__PURE__*/_createElementVNode("div", { class: "card-desc" }, " 신축성이 좋은 플라스틱 소재로 일회용 비닐장갑, 지퍼백 등 일상생활에 많이 쓰임 ")
], -1)
const _hoisted_177 = { class: "img-card" }
const _hoisted_178 = ["src"]
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", { class: "img-card-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, " HDPE "),
  /*#__PURE__*/_createElementVNode("div", { class: "card-desc" }, " 조금 더 단단한 재질로 식품 포장 비닐 혹은 일반 비닐봉지 등 일상생활에 많이 쓰임 ")
], -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "important" }, " *상기 이미지는 단편적 예시임을 말씀드립니다. ", -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " LDPE / HDPE 플라스틱은 수거 대상이 아닌가요? ", -1)
const _hoisted_183 = ["src"]
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 이번 쓰담쓰담 캠페인은 비닐 포장재 수거 캠페인으로 LDPE/HDPE 비닐 포장재가 수거 대상입니다. 기타 LDPE/HDPE 플라스틱 용기는 수거 대상이 아닙니다. ", -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "collapse-title" }, " Other 비닐 포장재는 수거 대상에서 제외인가요? ", -1)
const _hoisted_187 = ["src"]
const _hoisted_188 = /*#__PURE__*/_createElementVNode("div", { class: "faq-content" }, " 유한킴벌리 하기스 네이처메이드와 테라사이클이 진행하는 쓰담쓰담 캠페인은 올바른 비닐 포장재 분리배출 교육과 독려를 위해 기획됐습니다. 참여하시면서 직접 비닐 포장재의 분리배출 마크를 확인하는 습관을 형성하고자 합니다. 이번 캠페인은 LDPE/HDPE 비닐이 수거 대상으로 Other 마크가 있는 비닐 포장재는 수거 대상이 아닙니다. ", -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "screen-footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "footer-btn" }, " 캠페인 문의 "),
    /*#__PURE__*/_createElementVNode("p", null, " 카카오톡 채널 [테라사이클] 을 검색해주세요. "),
    /*#__PURE__*/_createElementVNode("div", { class: "border-text" }, " 운영 시간 : 평일 오전 10시 ~ 오후 6시 (주말 및 공휴일 제외) ")
  ])
], -1)

import { onMounted, ref } from 'vue';
  import { request } from '@/utils';
  import { IProgram } from '@/types/program';
  import Images from '../images';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  // 代码片段会注入 program, Images，这里引入只是为了调试
  const program = ref<IProgram>({} as IProgram);

  onMounted(async () => {
    const { data } = await request.get('/programs/1');
    program.value = data;
  });

return (_ctx: any,_cache: any) => {
  const _component_ProgramApplyButton = _resolveComponent("ProgramApplyButton")!
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppCollapse = _resolveComponent("AppCollapse")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(Images).CompaignHuggies.union,
            class: "img-union"
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    class: "img-leaf",
                    src: _unref(Images).CompaignHuggies.leaf,
                    alt: ""
                  }, null, 8, _hoisted_12),
                  _createElementVNode("img", {
                    class: "img-main",
                    src: _unref(Images).CompaignHuggies.mainImage,
                    alt: ""
                  }, null, 8, _hoisted_13)
                ])
              ]),
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  class: "img-frame",
                  src: _unref(Images).CompaignHuggies.frame
                }, null, 8, _hoisted_16)
              ]),
              _hoisted_17
            ])
          ]),
          _createElementVNode("img", {
            class: "img-logos",
            src: _unref(Images).CompaignHuggies.logos
          }, null, 8, _hoisted_21)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("img", {
            src: _unref(Images).CompaignHuggies.tcSymbol,
            class: "symbol-1"
          }, null, 8, _hoisted_25),
          _createElementVNode("img", {
            src: _unref(Images).CompaignHuggies.tcSymbol,
            class: "symbol-2"
          }, null, 8, _hoisted_26),
          _createElementVNode("img", {
            src: _unref(Images).CompaignHuggies.tcSymbol,
            class: "symbol-3"
          }, null, 8, _hoisted_27)
        ]),
        _createVNode(_component_AppTabs, { class: "page-tabs" }, {
          trigger: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_29, _toDisplayString(scope.label), 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("img", {
                src: scope.active ? _unref(Images).CompaignHuggies.tabIndicatorActive : _unref(Images).CompaignHuggies.tabIndicator
              }, null, 8, _hoisted_31)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(Images).CompaignHuggies.tcSymbol,
              class: "symbol-tab"
            }, null, 8, _hoisted_28),
            _createVNode(_component_AppTab, { label: "캠페인 참여" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_ProgramApplyButton, { program: program.value }, {
                    default: _withCtx(({ apply, loading }) => [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["btn", { disabled: loading }]),
                          style: _normalizeStyle({ backgroundImage: `url('${_unref(Images).CompaignHuggies.bgButton}')` }),
                          onClick: apply
                        }, " 수거 신청 ", 14, _hoisted_34)
                      ])
                    ]),
                    _: 1
                  }, 8, ["program"]),
                  _hoisted_35,
                  _hoisted_36,
                  _hoisted_37,
                  _hoisted_38,
                  _hoisted_39,
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("img", {
                      src: _unref(Images).CompaignHuggies.attention
                    }, null, 8, _hoisted_42),
                    _hoisted_43
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_AppTab, { label: "재활용 공정" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _hoisted_46,
                  _hoisted_47,
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("img", {
                            class: "img",
                            src: _unref(Images).CompaignHuggies.tab2Card1
                          }, null, 8, _hoisted_53),
                          _hoisted_54,
                          _hoisted_55,
                          _hoisted_56,
                          _hoisted_57,
                          _hoisted_58
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("img", {
                            class: "img",
                            src: _unref(Images).CompaignHuggies.tab2Card2
                          }, null, 8, _hoisted_61),
                          _hoisted_62,
                          _hoisted_63,
                          _hoisted_64,
                          _hoisted_65,
                          _hoisted_66
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("img", {
                            class: "img",
                            src: _unref(Images).CompaignHuggies.tab2Card3
                          }, null, 8, _hoisted_69),
                          _hoisted_70,
                          _hoisted_71,
                          _hoisted_72,
                          _hoisted_73,
                          _hoisted_74
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_AppTab, { label: "리워드" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _hoisted_77,
                  _hoisted_78,
                  _hoisted_79,
                  _createElementVNode("div", _hoisted_80, [
                    _hoisted_81,
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("img", {
                              class: "img",
                              src: _unref(Images).CompaignHuggies.tab3Card1
                            }, null, 8, _hoisted_87),
                            _hoisted_88,
                            _hoisted_89,
                            _hoisted_90
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("img", {
                              class: "img",
                              src: _unref(Images).CompaignHuggies.tab3Card2
                            }, null, 8, _hoisted_94),
                            _hoisted_95,
                            _hoisted_96
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_AppTab, { label: "FAQ" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_97, [
                  _hoisted_98,
                  _createVNode(_component_AppTabs, { class: "faq-tabs" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AppTab, { label: "참여신청" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_99,
                                _hoisted_100,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_101)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_102
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_103,
                                _hoisted_104,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_105)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_106
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_107,
                                _hoisted_108,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_109)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_110
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_111,
                                _hoisted_112,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_113)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_114
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_115,
                                _hoisted_116,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_117)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_118
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_119,
                                _hoisted_120,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_121)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_122
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppTab, { label: "수거신청" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_123,
                                _hoisted_124,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_125)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_126
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_127,
                                _hoisted_128,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_129)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_130
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_131,
                                _hoisted_132,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_133)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_134
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_135,
                                _hoisted_136,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_137)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_138
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_139,
                                _hoisted_140,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_141)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_142
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_143,
                                _hoisted_144,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_145)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_146
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppTab, { label: "재활용" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_147,
                                _hoisted_148,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_149)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_150
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_151,
                                _hoisted_152,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_153)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_154
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_155,
                                _hoisted_156,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_157)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_158
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppTab, { label: "리워드" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_159,
                                _hoisted_160,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_161)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_162
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_163,
                                _hoisted_164,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_165)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_166
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppTab, { label: "수거품목 예시" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_167,
                                _hoisted_168,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_169)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_170, [
                                _hoisted_171,
                                _hoisted_172,
                                _createElementVNode("div", _hoisted_173, [
                                  _createElementVNode("div", _hoisted_174, [
                                    _createElementVNode("img", {
                                      src: _unref(Images).CompaignHuggies.LDPE
                                    }, null, 8, _hoisted_175),
                                    _hoisted_176
                                  ]),
                                  _createElementVNode("div", _hoisted_177, [
                                    _createElementVNode("img", {
                                      src: _unref(Images).CompaignHuggies.HDPE
                                    }, null, 8, _hoisted_178),
                                    _hoisted_179
                                  ])
                                ]),
                                _hoisted_180
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_181,
                                _hoisted_182,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_183)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_184
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AppCollapse, { class: "faq-collapse" }, {
                            trigger: _withCtx(({ visible }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                              }, [
                                _hoisted_185,
                                _hoisted_186,
                                _createElementVNode("img", {
                                  class: "indicator",
                                  src: _unref(Images).CompaignHuggies.arrowDown
                                }, null, 8, _hoisted_187)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_188
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_AppTab, {
              label: "맘큐",
              href: "https://www.momq.co.kr/shop/neoevent_view.html?ev_no=202203250002",
              target: "_blank"
            })
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_189
  ]))
}
}

})